export const getDateByMs = (ms?: number) => {
  if (!ms) return '-';
  const date = new Date(ms * 1000);
  return date.toLocaleDateString('pt-BR');
};
